import { EuiSwitch } from "@elastic/eui";
import { useContext } from "react";

import ThemeContext from "../contexts/themeContext";
import $ from "jquery";

export default function ThemeSetter() {
  const { theme, setTheme } = useContext(ThemeContext);

  $(function() {
    if (theme === 'light') {
      $("#lightThemeSpan").addClass("isSelected");
      $("html").addClass('lightSelected');
      $("html").removeClass('darkSelected');
    }else{
      $("#lightThemeSpan").removeClass("isSelected");
      $("html").addClass('darkSelected');
      $("html").removeClass('lightSelected');
    }
  });

  return (
    <EuiSwitch
      id='themeSwitch'
      label="Dark"
      checked={theme == 'light' ? false : true}
      onChange={(e) => {
        let themeChecked = '';
        const valueChecked = e.target.checked;

        if (!valueChecked) {
          themeChecked = 'light';
        }else{
          themeChecked = 'dark';
        }
        
        setTheme(themeChecked);
      }} />
  );
}

